<template>
  <div>
    <GroupHeader :width="1305" :left="556" :top="130" :title="$t('Monitoring1025.historyData')" />
    <div class="his-container" :style="{ width: width + 'px', height: height + 'px', left: left + 'px', top: top + 'px' }">
      <div class="left">
        <div class="cat-container">
          <!-- 时间 -->
          <div class="time-slot">
            <span>{{ $t('Monitoring1025.timeSlot') }}</span>
            <div class="time-container">
              <span class="tip-title">{{ $t('Monitoring1025.startTime') }}</span>
              <el-date-picker v-model="cbdt" :editable="false" type="datetime" :placeholder="$t('Monitoring1025.selectTime')"></el-date-picker>
            </div>
            <div class="time-container">
              <span class="tip-title">{{ $t('Monitoring1025.endTime') }}</span>
              <el-date-picker v-model="cedt" :editable="false" type="datetime" :placeholder="$t('Monitoring1025.selectTime')"></el-date-picker>
              <div @click="confirmBtnClicked" class="confirm-btn">{{ $t('Monitoring1025.confirm') }}</div>
            </div>
          </div>
          <div class="time-slot">
            <span>{{ $t('Monitoring1025.element') }}</span>
            <ul class="cat-list-container">
              <li class="cat-item" @click="changeShowCatIndex(0)">
                <span :class="{ box: true, 'box1-selected': this.selectedCats.indexOf(0) != -1 }"></span>
                <span>{{ $t('Monitoring1025.windSpeed') }}</span>
              </li>
              <li class="cat-item" @click="changeShowCatIndex(1)">
                <span :class="{ box: true, 'box2-selected': this.selectedCats.indexOf(1) != -1 }"></span>
                <span>{{ $t('Monitoring1025.windDirection') }}</span>
              </li>
              <li class="cat-item" @click="changeShowCatIndex(2)">
                <span :class="{ box: true, 'box3-selected': this.selectedCats.indexOf(2) != -1 }"></span>
                <span>{{ $t('Monitoring1025.humidity') }}</span>
              </li>
              <li class="cat-item" @click="changeShowCatIndex(3)">
                <span :class="{ box: true, 'box4-selected': this.selectedCats.indexOf(3) != -1 }"></span>
                <span>{{ $t('Monitoring1025.airPressure') }}</span>
              </li>
            </ul>
            <ul class="cat-list-container">
              <li class="cat-item" @click="changeShowCatIndex(4)">
                <span :class="{ box: true, 'box5-selected': this.selectedCats.indexOf(4) != -1 }"></span>
                <span>{{ $t('Monitoring1025.waveHeight') }}</span>
              </li>
              <li class="cat-item" @click="changeShowCatIndex(5)">
                <span :class="{ box: true, 'box6-selected': this.selectedCats.indexOf(5) != -1 }"></span>
                <span>{{ $t('Monitoring1025.waveDirection') }}</span>
              </li>
              <li class="cat-item" @click="changeShowCatIndex(6)">
                <span :class="{ box: true, 'box7-selected': this.selectedCats.indexOf(6) != -1 }"></span>
                <span>{{ $t('Monitoring1025.wavePeriod') }}</span>
              </li>
              <li class="cat-item" @click="changeShowCatIndex(7)">
                <span :class="{ box: true, 'box8-selected': this.selectedCats.indexOf(7) != -1 }"></span>
                <span>{{ $t('Monitoring1025.surfaceTemp') }}</span>
              </li>
            </ul>
          </div>
        </div>
        <!-- 历史数据 -->
        <div id="historyChart" class="history-chart"></div>
      </div>
      <!-- 玫瑰图 -->
      <WindRoseChart :roseData="roseData" />
    </div>
  </div>
</template>
<script>
import GroupHeader from './GroupHeader.vue'
import WindRoseChart from './WindRoseChart.vue'
import * as echarts from 'echarts'

export default {
  props: {
    width: {
      type: Number,
      default: 1300
    },
    height: {
      type: Number,
      default: 429
    },
    left: {
      type: Number,
      default: 561
    },
    top: {
      type: Number,
      default: 176
    },
    historyData: {
      type: Array
    },
    roseData: {
      type: Array
    },
    bdt: {
      type: String,
      default: ''
    },
    edt: {
      type: String,
      default: ''
    }
  },
  components: { GroupHeader, WindRoseChart },
  data() {
    return {
      historyChart: null,
      selectedCats: [],
      linedatas: [],
      cbdt: '',
      cedt: '',
      maxNumbers: [], // 记录8个最大的数字
      maxNumber: 80 // 计算当前的最大值
    }
  },
  watch: {
    bdt: {
      handler(val) {
        this.cbdt = new Date(val)
        console.log(this.cbdt)
      },
      immediate: true
    },
    edt: {
      handler(val) {
        this.cedt = new Date(val)
        console.log(this.cedt)
      },
      immediate: true
    },
    historyData(newVal) {
      if (newVal != null && Array.isArray(newVal)) {
        this.selectedCats = [0]
        // 数据
        let timeArrs = [],
          linedatas = [],
          data1 = [],
          data2 = [],
          data3 = [],
          data4 = [],
          data5 = [],
          data6 = [],
          data7 = [],
          data8 = []
        for (let i = 0; i < newVal.length; i++) {
          let item = newVal[i]
          // 时间
          let index1 = item['时间'].indexOf('/')
          let index2 = item['时间'].lastIndexOf(':')
          timeArrs.push(item['时间'].substring(index1 + 1, index2))
          // 数据
          data1.push(parseFloat(Number(item[window.guiyanaWindKey]).toFixed(2)))
          data2.push(parseFloat(Number(item['Wind Direction']).toFixed(2)))
          data3.push(parseFloat(Number(item['Relative humidity']).toFixed(2)))
          data4.push(parseFloat(Number(item['Air Pressure(hPa)']).toFixed(2)))
          data5.push(parseFloat(Number(item['1/3 Wave Height(m)']).toFixed(2)))
          data6.push(parseFloat(Number(item['Wave Direction(°)']).toFixed(2)))
          data7.push(parseFloat(Number(item['1/3 Wave Period(s)']).toFixed(2)))
          data8.push(parseFloat(Number(item[window.guiyanaTempKey]).toFixed(2)))
        }
        this.timeArrs = timeArrs
        this.maxNumbers = []
        linedatas.push(data1)
        this.maxNumbers.push(Math.max(...data1))
        linedatas.push(data2)
        this.maxNumbers.push(Math.max(...data2))
        linedatas.push(data3)
        this.maxNumbers.push(Math.max(...data3))
        linedatas.push(data4)
        this.maxNumbers.push(Math.max(...data4))
        linedatas.push(data5)
        this.maxNumbers.push(Math.max(...data5))
        linedatas.push(data6)
        this.maxNumbers.push(Math.max(...data6))
        linedatas.push(data7)
        this.maxNumbers.push(Math.max(...data7))
        linedatas.push(data8)
        this.maxNumbers.push(Math.max(...data8))
        this.linedatas = linedatas
        this.setLineChartOptions()
      }
    }
  },
  methods: {
    initChart() {
      this.historyChart = echarts.init(document.getElementById('historyChart'))
      // this.setLineChartOptions(this.historyChart)
    },
    changeShowCatIndex(index) {
      let position = this.selectedCats.indexOf(index)
      if (position != -1) {
        this.selectedCats = this.selectedCats.filter(item => item != index)
      } else {
        this.selectedCats.push(index)
      }
      this.setLineChartOptions()
    },
    setLineChartOptions() {
      let maxNumber = 0
      if (this.selectedCats.length != 0) {
        for (let i = 0; i < this.selectedCats.length; i++) {
          maxNumber = Math.max(maxNumber, this.maxNumbers[this.selectedCats[i]])
        }
        if (maxNumber > 1) {
          maxNumber = parseInt(maxNumber)
          if (maxNumber == 0) {
            maxNumber = parseFloat(maxNumber) + 0.2
          } else if (maxNumber < 5) {
            maxNumber += 1.0
          } else if (maxNumber < 10) {
            maxNumber += 2.0
          } else if (maxNumber < 50) {
            maxNumber = Math.ceil(maxNumber / 10) * 10
          } else if (maxNumber < 500) {
            maxNumber = Math.ceil(maxNumber / 100) * 100
          } else if (maxNumber > 1000) {
            maxNumber = Math.ceil(maxNumber / 100) * 100
          }
        } else {
          maxNumber += 0.1
        }
        this.maxNumber = maxNumber
      } else {
        maxNumber = this.maxNumber
      }
      const maxDataArr = new Array(this.linedatas[0].length).fill(maxNumber)
      // 组织数据
      let series = [
        {
          type: 'bar',
          data: maxDataArr,
          barWidth: '80%', // Set the width of the bars
          itemStyle: {
            color: 'rgba(10, 45, 78, 0.5)'
          }
        }
      ]

      for (let i = 0; i < this.selectedCats.length; i++) {
        // 第几个
        let index = this.selectedCats[i]
        let data = this.linedatas[index]
        let lineColor = this.lineColors[index]
        let lineAreaColor = this.lineAreaColors[index]
        let line = {
          data,
          type: 'line',
          areaStyle: {
            color: lineAreaColor
          },
          lineStyle: {
            color: lineColor
          },
          itemStyle: {
            color: lineColor
          },
          label: {
            show: true,
            position: 'top',
            color: lineColor
          }
        }
        series.push(line)
      }

      let option = {
        grid: {
          top: '2%',
          bottom: '10%',
          right: '2%',
          left: '4%'
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.timeArrs,
          axisLabel: {
            textStyle: {
              color: '#7CC5F7',
              fontSize: 10,
              width: 2
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          max: maxNumber,
          axisLabel: {
            textStyle: {
              color: '#7CC5F7',
              fontSize: 10,
              width: 2
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(10, 45, 78, 0.5)'
            }
          }
        },
        series: series
      }
      this.historyChart.setOption(option, true)
    },
    confirmBtnClicked() {
      if (this.cbdt > this.cedt) {
        this.$message({
          message: 'Please select the start time before the end time',
          type: 'warning'
        })
      } else {
        this.$emit('refresh', this.cbdt, this.cedt)
      }
    }
  },
  created() {
    // 选择的索引和颜色列表 rgba(98, 162, 205, 1)
    this.lineColors = [
      'rgba(0, 174, 255, 1)',
      'rgba(98, 217, 173, 1)',
      'rgba(121, 145, 195, 1)',
      'rgba(121, 211, 255, 1)',
      'rgba(255, 220, 76, 1)',
      'rgba(255, 151, 76, 1)',
      'rgba(230, 90, 86, 1)',
      'rgba(109, 97, 228, 1)'
    ]
    this.lineAreaColors = [
      'rgba(0, 174, 255, 0.4)',
      'rgba(98, 217, 173, 0.4)',
      'rgba(121, 145, 195, 0.4)',
      'rgba(121, 211, 255, 0.4)',
      'rgba(255, 220, 76, 0.4)',
      'rgba(255, 151, 76, 0.4)',
      'rgba(230, 90, 86, 0.4)',
      'rgba(109, 97, 228, 0.4)'
    ]
  },
  mounted() {
    this.initChart()
  },
  destroyed() {
    if (this.historyChart) {
      this.historyChart.dispose()
      this.historyChart = null
    }
  }
}
</script>

<style lang="scss" scoped>
.his-container {
  position: absolute;
  background: rgba(23, 78, 128, 0.22);
  display: flex;
  justify-content: space-between;

  .left {
    .cat-container {
      margin: 15px 0 0 40px;
      width: 800px;
      height: 78px;
      display: flex;
      justify-content: space-between;

      .time-slot {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 16px;
        color: #00f3fb;
        font-weight: bold;

        .tip-title {
          width: 30px;
          font-size: 12px;
          color: #00f3fb;
          font-weight: bold;
        }

        .time-container {
          display: flex;
          align-items: center;
          align-items: center;
          font-size: 13px;
          color: #ffffff;
          font-weight: bold;
          cursor: pointer;

          .time-text {
            margin-left: 6px;
          }

          .confirm-btn {
            width: 56px;
            height: 16px;
            background: rgba(107, 206, 255, 0.6);
            color: black;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 2px;
            font-size: 10px;
            margin-left: 16px;
            cursor: pointer;
          }
        }
      }

      .cat-list-container {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .cat-item {
          width: 115px;
          font-size: 12px;
          color: #ffffff;
          font-weight: bold;
          cursor: pointer;
          display: flex;
          align-items: center;

          .box {
            display: inline-block;
            width: 10px;
            height: 10px;
            margin-right: 4px;
            border: 1px solid #62a2cd;
            background-color: transparent;
          }

          .box1-selected {
            background: #00aeff;
          }

          .box2-selected {
            background: #62d9ad;
          }

          .box3-selected {
            background: #7991c3;
          }

          .box4-selected {
            background: #79d3ff;
          }

          .box5-selected {
            background: #ffdc4c;
          }

          .box6-selected {
            background: #ff974c;
          }

          .box7-selected {
            background: #e65a56;
          }

          .box8-selected {
            background: #6d61e4;
          }
        }
      }
    }

    .history-chart {
      width: 900px;
      height: 300px;
      margin: 16px 0 0 30px;
    }
  }

  .el-date-editor.el-input {
    width: 140px;
    margin-left: 6px;
  }
  ::v-deep .el-input__prefix {
    display: none;
  }

  ::v-deep .el-input__inner {
    padding: 0;
    background-color: transparent;
    color: white;
    border: 0;
  }
}
</style>
